import { useTranslation } from 'react-i18next';
import { setLocale } from '../../i18n';

export default function LanguageToggle({ className = '' }: { className?: string }) {
  const { i18n } = useTranslation();
  const current = (i18n.language?.startsWith('en') ? 'en' : 'es') as 'en' | 'es';

  const linkClass = (active: boolean) =>
    `font-sans text-xs tracking-widestest uppercase px-1 transition-colors ${
      active ? 'text-brand-gold' : 'text-brand-ink/60 hover:text-brand-gold'
    }`;

  return (
    <div role="group" aria-label="Language toggle" className={`inline-flex items-center gap-1 ${className}`}>
      <button type="button" className={linkClass(current === 'es')} aria-pressed={current === 'es'} onClick={() => setLocale('es')}>
        ES
      </button>
      <span aria-hidden="true" className="text-brand-ink/40">|</span>
      <button type="button" className={linkClass(current === 'en')} aria-pressed={current === 'en'} onClick={() => setLocale('en')}>
        EN
      </button>
    </div>
  );
}
